// «Отправка с iPhone» (R03.1): быстрая команда iOS шлёт PDF POST-запросом с ключом MCP на
// /ingest/inbody (приём строит бэкенд, пакет app/ingest). Адрес — тот, по которому открыто приложение.
// Настраивается один раз, поэтому инструкция свёрнута; адрес копируется кнопкой.

import { Link } from 'react-router-dom'

import { Button, Card, Icon, useToast } from '@/components/ui'

export const INGEST_PATH = '/ingest/inbody'

function Code({ children }: { children: string }) {
  return <code className="break-all rounded bg-surface-2 px-1.5 py-0.5 font-mono text-xs text-fg">{children}</code>
}

export function IPhoneHelp({ origin = window.location.origin }: { origin?: string }) {
  const url = `${origin}${INGEST_PATH}`
  const toast = useToast()
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      toast.show({ message: 'Адрес скопирован', tone: 'accent' })
    } catch {
      toast.show({ message: 'Не получилось скопировать — выдели адрес вручную', tone: 'danger' })
    }
  }
  return (
    <Card title="Отправка с iPhone" subtitle="На iPhone нет «Поделиться» в веб-приложение — поможет быстрая команда">
      <details className="group">
        <summary className="-my-1 flex min-h-11 cursor-pointer list-none items-center gap-1.5 text-sm font-medium text-accent [&::-webkit-details-marker]:hidden">
          Как настроить
          <Icon name="chevron-down" size={18} className="transition-transform group-open:rotate-180" />
        </summary>
      <ol className="mt-2 flex list-decimal flex-col gap-2 pl-5 text-sm text-fg">
        <li>
          Выпусти ключ в{' '}
          <Link to="/settings/mcp" className="text-accent underline-offset-2 hover:underline">
            настройках MCP
          </Link>{' '}
          — он начинается с <Code>hk_</Code>. Подойдёт и ключ, который уже есть у бота.
        </li>
        <li>
          В приложении «Команды» создай команду, в её настройках включи «Показывать в меню „Поделиться“» и выбери
          тип входных данных «PDF».
        </li>
        <li>
          Добавь действие «Получить содержимое URL»: адрес <Code>{url}</Code>, метод <Code>POST</Code>, заголовок{' '}
          <Code>Authorization</Code> со значением <Code>Bearer &lt;ключ MCP&gt;</Code>.
          <Button size="sm" icon="copy" className="mt-2 flex" onClick={() => void copy()}>
            Скопировать адрес
          </Button>
        </li>
        <li>
          Тело запроса — «Форма»: поле <Code>file</Code> типа «Файл», значение — «Входные данные команды». Можно и
          «Файл» целиком — сервер примет сырой PDF.
        </li>
        <li>
          В DDX открой отчёт → «Поделиться» → твоя команда. Отчёт появится в «Ждут проверки», придёт уведомление.
          Чтобы сохранять сразу, если сверка прошла без замечаний, добавь к адресу <Code>?save=1</Code>.
        </li>
      </ol>
      </details>
    </Card>
  )
}
